export const STORE_DETAIL = 'store_detail'
export const STORE_LIST = 'STORE_LIST'